import React from 'react';

const About = () => {
    return (
        <div>
            <h1>About Us</h1>
            <p>
                Blog Agency is a platform dedicated to sharing insights on various topics, from technology to lifestyle.
            </p>
        </div>
    );
};

export default About;
